module.exports = __webpack_public_path__ + "img/tree-03-f-leaves.d34e6a46.png";